import { NavLink, useNavigate } from 'react-router-dom';
import './Sidebar.css';
import {
  FaUsers, FaSignOutAlt, FaCog,
  FaUser,
  FaHandshake,
  FaMedal,
  FaMoneyBillWave,
  FaEnvelope,
} from 'react-icons/fa';
import { MdAccountBalanceWallet, MdHelpCenter } from "react-icons/md";
import { HiCash, HiUsers } from "react-icons/hi";
import { IoMdSettings } from "react-icons/io";
import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../pages/config';
import { ReactComponent as UserSettingIcon } from "../assets/icons/userSetting.svg"
import { ReactComponent as UserIdCardIcon } from "../assets/icons/userIdCard.svg"
import { ReactComponent as LinkIcon } from "../assets/icons/link.svg"
import { ReactComponent as EditUserIcon } from "../assets/icons/editUser.svg"
import { ReactComponent as FaqIcon } from "../assets/icons/faq.svg"
import { ReactComponent as UserIcon } from "../assets/icons/user.svg"
import { ReactComponent as ClubIcon } from "../assets/icons/club.svg"
import { ReactComponent as EarningDisclaimerIcon } from "../assets/icons/earningDisclaimer.svg"

function Sidebar({ isOpen, toggleSidebar }) {
  const isAdmin = localStorage.getItem('isAdmin') === '1';
  const iscallcenter = localStorage.getItem('isCallCenter') === '1';
  const username = localStorage.getItem('username');
  const userId = localStorage.getItem('userId');

  const navigate = useNavigate();
  const [paymentStatus, setPaymentStatus] = useState('');
  const [referUserName, setReferUserName] = useState('');
  const [loading, setLoading] = useState(true);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/member/loginPage');
  };

  useEffect(() => {
    fetch(`${API_BASE_URL}/user-payment-status/${userId}`)
      .then(res => res.json())
      .then(data => {
        if (data.paymentStatus) {
          console.log("data", data)
          setPaymentStatus(data.paymentStatus);
          setReferUserName(data.referUserName);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [userId]);

  return (
    <>

      <aside className={`sidebar ${isOpen ? 'open' : 'collapsed'}`}>
        <ul className="sidebar-menu">
          {isAdmin ? (
            <>
              <li className="disabled-link">
                <div className="menu-item">
                  <FaUser /> <span>Your VIRON Username: {username}</span>
                </div>
              </li>
              <li>
                <NavLink to="/member/admin/userlist" className={({ isActive }) => isActive ? 'active' : ''}>
                  <FaUsers /> <span>User List</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/member/admin/memberlist" className={({ isActive }) => isActive ? 'active' : ''}>
                  <FaUsers /> <span>Internal User List</span>
                </NavLink>
              </li>

              {/* WEEKLY COMMISSION - DEMO */}
              <li>
                <NavLink to="/member/admin/weeklycommission" className={({ isActive }) => isActive ? 'active' : ''}>
                  <FaMoneyBillWave /> <span>Weekly Commission</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/member/admin/emailmanagement" className={({ isActive }) => isActive ? 'active' : ''}>
                  <FaEnvelope /> <span>Email Management</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/member/admin/adminedit" className={({ isActive }) => isActive ? 'active' : ''}>
                  <FaCog /> <strong>Edit Your Account Information</strong>
                </NavLink>
              </li>
              <li>
                <button className="logout-btn" onClick={handleLogout}>
                  <FaSignOutAlt /> <span>Logout</span>
                </button>
              </li>

            </>
          ) : (
            <>
              {iscallcenter ? (
                <>
                  <li className="disabled-link">
                    <div className="menu-item">
                      <FaUser /> <span>Your VIRON Username: {username}</span>
                    </div>
                  </li>
                  <li>
                    <NavLink to="/member/userlist" className={({ isActive }) => isActive ? 'active' : ''}>
                      <FaUsers /> <span>User List</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/member/member-support-edit" className={({ isActive }) => isActive ? 'active' : ''}>
                      <FaCog /> <strong>Edit Your Account Information</strong>
                    </NavLink>
                  </li>
                  <li>
                    <button className="logout-btn" onClick={handleLogout}>
                      <FaSignOutAlt /> <span>Logout</span>
                    </button>
                  </li>
                </>
              ) : (
                <>
                  <li>
                    <NavLink to="/member/center" className={({ isActive }) => isActive ? 'active' : ''}>
                      {/* <FaTachometerAlt /> <span>MEMBER CENTER</span> */}
                      <UserSettingIcon /> <span><b>MEMBER CENTER – HOME</b></span>
                    </NavLink>
                  </li>

                  <li className="disabled-link">
                    <div className="menu-item">
                      {/* <FaUser /> <span>Your VIRON Username:<br />{username}</span> */}
                      <UserIdCardIcon /> <span>Your VIRON Username: <span className='text-light-blue'>{username}</span></span>
                    </div>
                  </li>
                  <li>
                    <a href={`https://viron.network/${username}`} target="_blank" rel="noopener noreferrer">
                      {/* <FaExternalLinkAlt /> */}
                      <LinkIcon />
                      <span>Your VIRON Referral Link:<br /><span className='text-light-blue'>viron.network/{username}</span></span>
                    </a>
                  </li>

                  <li>
                    <NavLink to="/member/referral-and-earings" className={({ isActive }) => isActive ? 'active' : ''}>
                      <HiUsers /> <span><b>My Referral & Earnings List</b></span>
                    </NavLink>
                  </li>

                  {/* My Referral & Earnings - DEMO */}
                  {/* <li>
                    <NavLink to="/member/referralearings" className={({ isActive }) => isActive ? 'active' : ''}>
                      <FaMoneyBillWave /> <span>My Referral & Earnings</span>
                    </NavLink>
                  </li> */}

                  <li>
                    <NavLink to="/member/affilateprogram" className={({ isActive }) => isActive ? 'active' : ''}>
                      <HiCash /> <span>VIRON Affiliate Program (VAP)</span>
                    </NavLink>
                  </li>

                  <li className="disabled-link">
                    <div className="menu-item">
                      {/* <MdOutlinePayments /> */}
                      <MdAccountBalanceWallet />
                      <span>
                        Your ("O") Account Status:{" "}
                        <span style={{
                          color:
                            paymentStatus === "Engaged" ? "red" :
                              paymentStatus === "in-Active" ? "red" :
                                paymentStatus === "Verification Pending" ? "#8b5d0e" : "black",
                          fontWeight: "bold",
                        }}>
                          {paymentStatus}
                        </span>
                      </span>
                    </div>
                  </li>

                  <li className="disabled-link">
                    <div className="menu-item">
                      <FaHandshake /> <span>Your SPONSOR Username: <span className='text-light-blue'>{referUserName}</span></span>
                    </div>
                  </li>

                  <li className="menu-group-title">PAYMENT AREA For:</li>
                  {/* <li>
                    <NavLink to="/member/PAYMENT/TXC-ACCOUNT-Setup" className={({ isActive }) => isActive ? 'active' : ''}>
                      // <FaDotCircle /> <span className='text-red'>-TEXITcoin (TXC) ACCOUNT Set-Up</span> 
                      <EditUserIcon /> <span className='text-red'>TEXITcoin (TXC) ACCOUNT Set-Up</span>
                    </NavLink>
                  </li> */}
                  <li>
                    <NavLink to="/member/DRs-Purchase" className={({ isActive }) => isActive ? 'active' : ''}>
                      {/* <FaDotCircle /> <span className='text-red'>-DIRECT REFERRALS (DRS) Purchase</span> */}
                      <UserIcon /> <span className='text-red'>DIRECT REFERRALS (DRs) Purchase</span>
                    </NavLink>
                  </li>
                  {/* <li>
                    <NavLink to="/member/Save-Club" className={({ isActive }) => isActive ? 'active' : ''}>
                      <FaUsers /> <span className='text-light-gray' style={{ fontWeight: "bold" }}>Activate: SAVE CLUB (SC)</span>
                    </NavLink>
                  </li> */}

                  {/* <li className="menu-group-title">INFORMATION & RESOURCES:</li>
                  <li>
                    <NavLink to="/member/expectations-of-viron" className={({ isActive }) => isActive ? 'active' : ''}>
                      <FaDotCircle /> <span>EXPECTATIONS of VIRON</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/member/core-perspective-of-viron" className={({ isActive }) => isActive ? 'active' : ''}>
                      <FaDotCircle /> <span>Core Perspective of VIRON</span>
                    </NavLink>
                  </li> */}

                  <li className="menu-group-title">INFORMATION & RESOURCES:</li>
                  <li>
                    <NavLink to="/member/mlm-qualifications" className={({ isActive }) => isActive ? 'active' : ''}>
                      {/* <FaDotCircle /> <span>MLM Company Qualifications</span> */}
                      <FaMedal /> <span>MLM Company Qualifications</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/member/why-TEXITcoin-TXC" className={({ isActive }) => isActive ? 'active' : ''}>
                      {/* <FaDotCircle /> <span>Why TEXITcoin (TXC) is Qualified</span> */}
                      <MdHelpCenter /> <span><strong>Why TEXITcoin (TXC) is Qualified</strong></span>
                    </NavLink>
                  </li>

                  {/* <li className="menu-group-title">MLM COMPANY INFORMATION:</li> */}
                  <li>
                    <NavLink to="/member/earnings-disclaimers" className={({ isActive }) => isActive ? 'active' : ''}>
                      {/* <FaDotCircle /> <span>Earnings Disclaimers</span> */}
                      {/* <ShieldIcon /> <span>Earnings Disclaimers</span> */}
                      <EarningDisclaimerIcon /> <span>Earnings Disclaimers</span>
                    </NavLink>
                  </li>
                  {/* <li>
                    <NavLink to="/member/expectations-of-viron" className={({ isActive }) => isActive ? 'active' : ''}>
                      <AiFillStar /> <span>Expectations of VIRON</span>
                    </NavLink>
                  </li> */}
                  <li>
                    <NavLink to="/member/faq" className={({ isActive }) => isActive ? 'active' : ''}>
                      <FaqIcon /> <span>Frequently Asked Questions (FAQ)</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/member/edit-account" className={({ isActive }) => isActive ? 'active' : ''}>
                      {/* <FaCog /> <strong>Edit Your Account Information</strong> */}
                      <IoMdSettings /> <strong>Edit Your Account Information</strong>
                    </NavLink>
                  </li>

                  <li className="text-center">
                    <button className="logout-btn mt-10" onClick={handleLogout}>
                      <FaSignOutAlt /> <span>Logout</span>
                    </button>
                  </li>
                </>
              )}
            </>
          )}
        </ul>
      </aside>
    </>
  );
}

export default Sidebar;
